import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const useCloneBtnParams = () => {
  const type = useSalesChannelType();

  if (type === ChannelType.MiniProgram) {
    return {
      [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
    };
  }
  if (type === ChannelType.Website) {
    return {
      [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
      [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true,
      [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
    };
  }
  return {};
};

export { useCloneBtnParams };
